import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-confirm',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule],
    template: `
    <h3 mat-dialog-title>{{title}}</h3>
    <mat-dialog-content>
      {{message}}
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button mat-dialog-close (click)="onDismiss()">No</button>
      <button mat-button mat-dialog-close cdkFocusInitial (click)="onConfirm()">Yes</button>
    </mat-dialog-actions>
  `,
    styles: ['']
})
export class ConfirmComponent {
  message= '';
  title= '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.message = data.message;
    this.title = data.title;
  }

  onConfirm(){
    this.dialogRef.close(true);
  }

  onDismiss(){
    this.dialogRef.close(false);
  }
}
